import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UsersUserResponse } from '@libs/generated-types/users';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { isDocumentFile, isImageFile } from 'apps/webapp/src/app/@core/utils/file-type.utils';
import { Company } from 'libs/user/config/src/lib/types/user.enums';
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { FileType } from '../../../../../file-card/file-card.component';
import { RepositoryShowFileDialogComponent } from "../../../../../repository-show-file-dialog/repository-show-file-dialog.component";

@Component({
  selector: 'personal-contacts',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SelectModule,
    InputTextModule,
    DatePickerModule,
    TooltipModule,
    CheckboxModule,
    ButtonModule,
    RepositoryShowFileDialogComponent
  ],
  templateUrl: './personal-contacts.component.html',
  styleUrls: ['./personal-contacts.component.scss'],
  standalone: true,
})
export class PersonalContactsComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() me: UsersUserResponse | null = null;

  translate = inject(TranslateService);

  detailFileType = signal<FileType | undefined>(undefined);
  showDetailFileDialog = signal(false);
  fileName = signal<string | undefined>(undefined);

  isImage: boolean = false;
  isDoc: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.fileName.set(this.getDataProcessingByCompany());

    this.isImage = isImageFile(this.fileName() || '');
    this.isDoc = isDocumentFile(this.fileName() || '');
  }

  onCloseShowDialog(): void {
    this.showDetailFileDialog.set(false);
    this.detailFileType.set(undefined);
  }

  getDataProcessingByCompany() {
    const userCompany: string = this.me?.company || '';
    let link: string;

    switch (true) {
      case userCompany.toLowerCase().includes(Company.ATLANTIC_SRL.toLowerCase()):
        link = window.location.origin + '/policy/contatti_personali_atlantic.png';
        break;
      case userCompany.toLowerCase().includes(Company.ESSERBELLA_SPA.toLowerCase()):
        link = window.location.origin + '/policy/contatti_personali_esserbella.png';
        break;
      case userCompany.toLowerCase().includes(Company.ESSELUNGA_SPA.toLowerCase()):
        link = window.location.origin + '/policy/contatti_personali_esselunga.png';
        break;
      default:
        link = window.location.origin
        break;
    }

    return link;
  }

  openPrivacyPolicy(): void {
    if (this.isImage) this.detailFileType.set(FileType.Image);
    else if (this.isDoc) this.detailFileType.set(FileType.Doc);
    else this.detailFileType.set(undefined);

    this.showDetailFileDialog.set(true);
  }
}